import React from 'react'
import PropTypes from 'prop-types'
import {Button} from 'reactstrap'
import {trans, getFeature} from '@utils'
import {Link} from 'react-router-dom'
import UpgradeButton from "./UpgradeButton"

const UpgradeContent = props => {
    const {featureKey} = props
    //************************************//
    const feature = getFeature(featureKey)
    //************************************//
    return (
        <div className={'d-flex align-items-center justify-content-center flex-column container-fluid py-2'}
             style={{maxWidth: 700}}>
            <div>
                <img
                    style={{maxHeight: '200px'}}
                    // className='img-fluid'
                    src={require('../../../../assets/images/upgrade-cover.png').default}
                />
            </div>
            <div className={'d-flex align-items-center mt-1'}>
                <h3 className={'ml-25 font-weight-bolder'}>
                    {
                        trans('planning.upgradePlanHeader', {
                            featureTitle: trans(feature.title),
                            planTitle: feature.require
                        })
                    }
                </h3>
            </div>
            {/*<h3 className={'text-center'}>{feature.header}</h3>*/}
            <h6 className={'text-center mb-2'}>
                {trans('gen.planing.upgradePlanContent', {title: trans(feature.title), require: feature.require})}
            </h6>
            <h6 className={'text-center font-weight-bolder'}>
                {trans('planning.tryUpdateForFree')}
            </h6>
            {/*<ul className="">*/}
            {/*    {*/}
            {/*        _.map(feature.properties, (property, index) => {*/}
            {/*            return (*/}
            {/*                <li key={index}>*/}
            {/*                    <div className="">{property}</div>*/}
            {/*                </li>*/}
            {/*            )*/}
            {/*        })*/}
            {/*    }*/}
            {/*</ul>*/}
           <UpgradeButton title={trans('planning.tryItFree')} />
        </div>
    )
}

UpgradeContent.propTypes = {}

export default UpgradeContent
